import { SiteEndpoint } from '../common/endpoints';
import { ServerResponse, Site } from '../common/types';
import { deleteRequest, getRequest, postRequest, putRequest } from './requests';

export type EstimatedWaitTime = {
  estimatedWaitTimeInMinutes: number;
};

export interface CreateSiteRequest {
  name: string;
  id: number;
  isAcceptingOnlineOrders: boolean;
  latitude: string;
  longitude: string;
  numberofHotDrink: number;
  street1: string;
  street2: string;
  suburb: string;
  postCode: string;
  state: string;
  country: string;
  isColdDrinkStation: boolean;
  isHotFoodStation: boolean;
  isActive: boolean;
  /**
   * The registered business name for the site.
   */
  businessName: string;
  /**
   * The ABN for the site.
   */
  abnNumber: string;
  orderingOpenTime?: string | null;
  orderingCloseTime?: string | null;
}

export async function listSites(includeDisabled = false) {
  const query = includeDisabled ? '?includeDisabled=true' : '';
  const result: ServerResponse<Site[]> = await getRequest(`${SiteEndpoint}${query}`);
  return result;
}

export async function createSite(site: CreateSiteRequest) {
  const result: ServerResponse<Site> = await postRequest(`${SiteEndpoint}`, site);
  return result;
}

export async function updateSite(siteId: number | string, site: CreateSiteRequest) {
  const result: ServerResponse<Site> = await putRequest(`${SiteEndpoint}/${siteId}`, site);
  return result;
}

export async function deleteSite(siteId: number | string) {
  const result: ServerResponse<null> = await deleteRequest(`${SiteEndpoint}/${siteId}/remove`);
  return result;
}

export async function disableSite(siteId: number | string) {
  const result: ServerResponse<{ message: string; siteId: number }> = await postRequest(
    `${SiteEndpoint}/${siteId}/disable`,
    null,
  );
  return result;
}

export async function enableSite(siteId: number | string) {
  const result: ServerResponse<{ message: string; siteId: number }> = await postRequest(
    `${SiteEndpoint}/${siteId}/enable`,
    null,
  );
  return result;
}

export async function getEstimatedWaitTime(siteId: number) {
  const result: ServerResponse<EstimatedWaitTime> = await getRequest(
    `${SiteEndpoint}/${siteId}/estimated-wait-time`,
  );
  return result;
}

export async function adminToggleOnlineOrdering(siteId: number, isPaused: boolean) {
  const result: ServerResponse<null> = await postRequest(
    `${SiteEndpoint}/pause-online-ordering`,
    { siteId, isPaused }
  )
  return result
}

export default {
  listSites,
  createSite,
  updateSite,
  deleteSite,
  disableSite,
  enableSite,
  getEstimatedWaitTime,
  adminToggleOnlineOrdering
};

